module.exports = __webpack_public_path__ + "img/caret-down.79127290.svg";